import { z } from 'zod';
import { WORDING_KINDS } from '../email-wording';
import { idempotency } from './spine';

/**
 * Settings → Email → Edit wording (MAP 249 spec §6, ticket 05).
 *
 * The bounds here are the WIRE's only, generous on purpose: the service refuses a subject over
 * 150 characters or a message over 2,000 with a sentence the owner can act on
 * (`wordingFormProblem`), which a zod message is not. These only stop a payload nobody typed.
 */
const WIRE_SUBJECT = 1_000;
const WIRE_BODY = 10_000;

const kind = z.enum(WORDING_KINDS);

export const emailWordingKindInput = z.object({ kind });
export type EmailWordingKindInput = z.infer<typeof emailWordingKindInput>;

/** Save the shop's own wording for one kind (owner only). */
export const emailWordingSetInput = idempotency.extend({
  kind,
  subject: z.string().max(WIRE_SUBJECT),
  body: z.string().max(WIRE_BODY),
});
export type EmailWordingSetInput = z.infer<typeof emailWordingSetInput>;

/** "Reset to ours": the shop's row goes, and ServWell's wording is back (owner only). */
export const emailWordingResetInput = idempotency.extend({ kind });
export type EmailWordingResetInput = z.infer<typeof emailWordingResetInput>;

/**
 * The preview: the kind's saved wording, or `draft` (what the sheet holds, saved or not), rendered
 * by the send's own function on the shop's latest real record of the kind, or a sample.
 */
export const emailWordingPreviewInput = z.object({
  kind,
  draft: z
    .object({
      subject: z.string().max(WIRE_SUBJECT),
      body: z.string().max(WIRE_BODY),
    })
    .optional(),
});
export type EmailWordingPreviewInput = z.infer<typeof emailWordingPreviewInput>;
